import { useState } from 'react';
import classNames from 'classnames';
import NavLinkDropdown from './NavLinkDropdown';
import { handleGaClick, trackEventDirect } from './ga';
import type { NavPromoTile } from './types';

export default function NavLink({
  navLink,
  itemIndex,
  totalItems,
  promo,
  currencyCode,
  onPromoTermsClick,
  isGlobalEFlag,
  isGlobalESite,
}: {
  navLink: any;
  itemIndex: number;
  totalItems: number;
  promo: NavPromoTile;
  currencyCode?: string;
  onPromoTermsClick?: () => void;
  isGlobalEFlag?: boolean;
  isGlobalESite?: boolean;
}) {
  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => setIsHover(true);
  const handleMouseLeave = () => setIsHover(false);

  const navLinkLabel =
    typeof navLink?.itemMenu?.label === 'string' ? navLink?.itemMenu?.label : navLink?.itemMenu?.label?.Default;

  const handleClick = (e: any) => {
    handleGaClick(e, 'top_navigation_click', navLink?.itemMenu.url, navLinkLabel, 'top nav');
    trackEventDirect('Top Navigation', 'Click', navLinkLabel);
  };

  return (
    <li
      className={classNames({ open: isHover }) || undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <a
        className="nav-menu-item js-activated tw-font-nav-link hover:tw-no-underline"
        href={navLink?.itemMenu.url}
        onClick={handleClick}
        data-category={navLink?.itemMenu?.dataCategory}
        data-action={navLink?.itemMenu?.dataAction}
        data-label={navLink?.itemMenu?.dataLabel}
        data-noninteract="false"
      >
        {navLinkLabel}
      </a>
      {navLink?.itemMenu?.submenu && (
        <NavLinkDropdown
          navLink={navLink}
          itemIndex={itemIndex}
          totalItems={totalItems}
          onClick={() => {
            setIsHover(false);
          }}
          promo={promo}
          currencyCode={currencyCode}
          onPromoTermsClick={onPromoTermsClick}
          isGlobalEFlag={isGlobalEFlag}
          isGlobalESite={isGlobalESite}
        />
      )}
    </li>
  );
}
